exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.pre-intake--1xlycHhXMQjiNhWTHEBIwB {\n  font-size: .875rem;\n  line-height: 1.875rem;\n  color: #244861;\n}\n", ""]);

// exports
exports.locals = {
	"fieldValue": "pre-intake--1xlycHhXMQjiNhWTHEBIwB",
	"fieldValue": "pre-intake--1xlycHhXMQjiNhWTHEBIwB"
};